<template>
    <div class="nav-control row">
        <div class="col text-left">
            <button class="btn btn-success btn-prev" :disabled="currentPage===1" @click="previous">Back</button>
        </div>
        <div class="col text-right" v-if="currentPage!==maxPages">
            <button class="btn btn-success btn-next" :disabled="!nextPage" @click="next">{{nextLabel}}</button>
        </div>
        <div class="col text-right" v-else>
            <button class="btn btn-success btn-next" @click="finish" :disabled="!nextPage">Finish</button>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            currentPage:{
                default:0
            },
            nextPage:{
                default:true,
            },
            maxPages:{
                default:10
            },
            pageBeginSurvey:{
                default: 1
            }
        },
        methods:{
            next(){
                prolitEvents.$emit('Navigation:next');
            },
            previous(){
                prolitEvents.$emit('Navigation:previous');
            },
            finish(){
                prolitEvents.$emit('Navigation:finish');
            }
        },
        computed:{
            nextLabel(){
                return this.currentPage===this.pageBeginSurvey ? "Begin Survey" : "Next";
            }
        }

    }
</script>

<style>
    .nav-control.row {
        position: relative;
        float: left;
        width: 100%;
        padding-left: 70px;
        margin-bottom: 40px;
        padding-right: 40px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/common/Navigation.vue